module.exports = __webpack_public_path__ + "static/media/041-iceland.6fe61392.svg";